import React, { useCallback, useRef, useState, useMemo, useEffect } from "react";
import { connect } from "react-redux";
import RenderSelectBoxCell from "../../../../../common/RenderCell";
import  ManuallySelectSublotForShipment  from "./headerOperations/ManuallySelectSublotForShipment";
import {
    Column,
    DataGrid,
    Scrolling,
    FilterRow,
    FilterPanel,
    Paging,
    Editing,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    Selection,
    Toolbar,
    Item,
    RequiredRule,
    StateStoring,
    CustomRule
} from "devextreme-react/data-grid";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import "jspdf-autotable";
import { Button, SelectBox, TextArea, Popup } from 'devextreme-react';
import axios from "axios";
import { confirm, alert } from 'devextreme/ui/dialog';
import data from "../../../../../assets/apiRoutes.json";
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";
import { GridLayout } from "../../../../../common/GridLayout";
import SerialNumbersTab from "../../../../../wm/components/transactions/dataentry/detailtabs/SerialNumbersTab";
import DropDownButton from "devextreme-react/drop-down-button";
import notify from 'devextreme/ui/notify';
import {
    ReceivingMethodSubLot,
    ShowMasterSubLot,
    ReceivingMethodUnit,
    ShowMasterUnit,
    TransactionTypes,
    TransactionStatus,
    TransactionStage,
    DevextremeEnums,
    ItemTypes,
    Options,
    UseLocation
} from "../../../../../enum/Enum";
import { LoadPanel } from 'devextreme-react/load-panel';
import { WM, WMSInventoryUOMFlag } from "../../../../../const/constants";
import { MESSAGES } from "../../../../../common/Messages";
import { checkLocationClassOnPick } from "./locationClassCheck";
import Form from "../../../codes/subLotDataEntry/Form";
import { PickSequence, MethodShipments, SublotPickMethodShipments } from "../../../../../enum/TransactionDataEntryEnum";
import { getKeyByValue } from "../../../../../common/Utils";
import { ERROR_SEVERITY, formatErrorList } from "../../../../../common/apiErrors";
import { WmSubDetailOperations } from "../../../../../enum/Enum";
import GenerateAutoSubLotPopup from "./headerOperations/GenerateAutoSubLotPopup";
import UpdateSubDetailTotalWeight from "./headerOperations/UpdateSubDetailTotalWeight";
import EnterWeights from "./headerOperations/EnterWeights";
// The Sublots and Locations grids sit side by side, so they share a height - a taller Locations grid
// leaves dead space under the Sublots one and pushes its border below the fold.
const BOTTOM_GRID_HEIGHT = "40vh";

let availableFlag = "";
let comment = "";

function SubLotDetailTabs(props) {
    var accessToken = props.oidc.user.access_token;
    const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';
    const [showSerialNumberScreen, setSerialNumberScreen] = useState(false);
    const [manuallySelectSublotForShipment, setManuallySelectSublotForShipment] = useState(false);
    const subLotGridKey = "C8DA51A8-2558-4A7D-A351-0055B065EF44";
    const gridLocationKey = "4BC64D83-4CE8-4E0E-9887-00A3E22BD7EB";
    const [preventAutoSelect, setPreventAutoSelect] = useState(false);
    const [selectedSublotKeys, setSelectedSublotKeys] = useState([]);
    const [selectedSubLot, setSelectedSubLot] = useState(null);
    const [currentLocationLayout, setCurrentLocationLayout] = useState("Default");
    const allowedPageSizes = [10, 20, 100, 500, "all"];
    const [subLotCurrentLayout, setSubLotCurrentLayout] = useState("Default");
    const [selectedLocationKeys, setSelectedLocationKeys] = useState([]);
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const position = { of: '#accordion-containe2' };
    const [subLotId, setSubLotId] = useState(null);
    const [showAutoCreateSubLotsPopup, setShowAutoCreateSubLotsPopup] = useState({Visible:false,SubDetailRowId:null,SubLotCode:null,RSubLot:null,TransactionType:null,
        Stage:null,Records:null,ReceivingMethod:null,DuplicateSubLot:null,DetailRowId:null});
    const [showUpdateTotalWeightPopup, setUpdateTotalWeightPopup] = useState({visible:false,subDetail:null});
    const [showEnterWeightsPopup, setEnterWeightsPopup] = useState({visible:false,subDetail:null});
    const [showSubLotEntryScreen, setShowSubLotEntryScreen] = useState(false);
    const saveLocationState = useCallback((state) => { GridLayout.sendStorageRequest(gridLocationKey, "POST", accessToken, state, currentLocationLayout); }, [gridLocationKey, currentLocationLayout]);
    const loadLocationState = useCallback(() => { return GridLayout.sendStorageRequest(gridLocationKey, "GET", accessToken,null,currentLocationLayout); }, [currentLocationLayout]);
    const saveSubLotState = useCallback((state) => { GridLayout.sendStorageRequest(subLotGridKey, "POST", accessToken, state, subLotCurrentLayout); }, [subLotGridKey, subLotCurrentLayout]);
    const loadSubLotState = useCallback(() => { return GridLayout.sendStorageRequest(subLotGridKey, "GET", accessToken,null,subLotCurrentLayout); }, [subLotCurrentLayout]);
    const sublotMethod = props.profile?.SublotmethodShipments;
    const sublotPickMethod = props.profile?.SublotpickmethodShipments;
    const sublotPickSeqMethod = props.profile?.SublotpicksequenceShipments;
    const handleConfirmAutoCreateSerialNumbers = () => {
        const result = confirm("<i>This option automatically creates serial numbers for all sublots for the actual quantities entered. Do you wish to continue?</i>", "Confirm");
        result.then((dialogResult) => {
        if (dialogResult) {
            setSerialNumberScreen(true);
        } 
        });
    };
    // Extracted so the memo below can declare them as dependencies. WmSubDetailOperations is a
    // module constant, so the previous [WmSubDetailOperations] array never invalidated the memo and
    // the operations list was computed once, ignoring the selected row.
    const operationsTransactionType = props?.formFields?.TRANSACTIONTYPE;
    const operationsItemType = props?.selectedDetails?.itemType;
    const items = useMemo(() => {
      const src = WmSubDetailOperations ?? {};
      // Delphi disables (greys out) Manually Select Sublot For Shipment rather than hiding it, so the
      // user can see the option exists (uWMD0002.pas:7351-7364). Same treatment DetailsTab.js gives
      // the lot-level equivalent. The remaining pre-conditions stay in onItemClick, where each one
      // can explain itself.
      const manualSublotSelectionAllowed =
          operationsTransactionType === TransactionTypes.Shipment &&
          operationsItemType === ItemTypes.SubLot;
      // Delphi's Enter Weights menu item has no Visible/Enabled property anywhere, so it is live
      // for every transaction type and stage. It is greyed here only where the modern grid
      // already refuses to edit the quantity columns (Editing allowUpdating below), because this
      // operation writes them through a direct PUT that would otherwise bypass that gate.
      const enterWeightsBlocked =
          props.isCommittedTransaction === true || props.disableGridsForRFTransactions === true;

      // Every entry except Manually Select Sublot For Shipment acts on the highlighted sublot, so the
      // menu itself must stay reachable with an empty grid - that operation is precisely what you use
      // when there are no sublots yet. Delphi gates each entry on its own requirements
      // (uWMD0002.pas:7346-7370) rather than disabling the whole menu.
      const hasSelectedSublot = selectedSublotKeys && selectedSublotKeys.length > 0;
      const needsSelectedSublot = [
          WmSubDetailOperations.CreateSerialNumberForSublot,
          WmSubDetailOperations.AuotCreateSerialNumbers,
          WmSubDetailOperations.AutoCreateSubLots,
          WmSubDetailOperations.UpdateTotalWeight,
          WmSubDetailOperations.ShowSerialNumber,
          WmSubDetailOperations.AutoSelectLocation,
          WmSubDetailOperations.EnterWeights
      ];

      return Object.entries(src).filter(([key, value]) => {
        if( value === WmSubDetailOperations.AutoSelectLocation && operationsTransactionType !== TransactionTypes.Shipment)
            return false;
        return true;
    }).map(([key, value]) => {
        if (value === WmSubDetailOperations.ManuallySelectSublotForShipment)
            return { id: key, name: value, disabled: !manualSublotSelectionAllowed };
        if (value === WmSubDetailOperations.EnterWeights && enterWeightsBlocked)
            return { id: key, name: value, disabled: true };
        if (needsSelectedSublot.includes(value))
            return { id: key, name: value, disabled: !hasSelectedSublot };
        return { id: key, name: value };
    });
    }, [operationsTransactionType, operationsItemType, selectedSublotKeys, props.isCommittedTransaction, props.disableGridsForRFTransactions]);
    const onItemClick = async (e) => {
        let name = e.itemData?.name;
        if (name === WmSubDetailOperations.CreateSerialNumberForSublot) {
            setSerialNumberScreen(true);
            return;
        }
        if (name === WmSubDetailOperations.ManuallySelectSublotForShipment) {
            // Pre-conditions mirror opManuallySelectSublotsClick (uWMD0002.pas:14196-14291). The
            // Delphi menu item is also disabled unless the transaction is a Shipment and the item is
            // Sublot tracked (uWMD0002.pas:7346-7370), which the items useMemo above now handles.
            const grid = props.subLotdataGridRef?.current?.instance?.();
            if (grid && grid.hasEditData()) {
                alert(MESSAGES.SAVE_OR_CANCEL_DETAIL_FIRST, MESSAGES.INFORMATION);
                return;
            }
            if (props.formFields?.TRANSACTIONTYPE !== TransactionTypes.Shipment) {
                alert(MESSAGES.SHIPMENT_TYPE_REQUIRED, MESSAGES.INFORMATION);
                return;
            }
            if (!props.selectedDetails?.lotCode) {
                alert(MESSAGES.NO_LOT_CODE_ASSIGNED, MESSAGES.INFORMATION);
                return;
            }
            if (props.selectedDetails?.inventoryUomFlag !== WMSInventoryUOMFlag.Inventory) {
                alert(MESSAGES.INVENTORY_UNIT_REQUIRED, MESSAGES.INFORMATION);
                return;
            }
            if (!(Number(props.selectedDetails?.itemAvailable ?? 0) > 0)) {
                alert(MESSAGES.NO_AVAILABLE_QUANTITY_TO_SHIP, MESSAGES.INFORMATION);
                return;
            }
            if (props.formFields?.STAGE !== TransactionStage.Ready &&
                props.formFields?.STAGE !== TransactionStage.Completed) {
                alert(MESSAGES.READY_OR_COMPLETED_STAGE_REQUIRED, MESSAGES.INFORMATION);
                return;
            }
            setManuallySelectSublotForShipment(true);
            return;
        }
        if (name === WmSubDetailOperations.AuotCreateSerialNumbers) {
            handleConfirmAutoCreateSerialNumbers();
            return;
        }
        if (name === WmSubDetailOperations.AutoCreateSubLots) {
            // Get selected sublot - check state first, then try to get from grid
            let subLotToUse = selectedSubLot;
            if (!subLotToUse && props.subLotdataGridRef.current?.instance) {
                const selectedRowsData = props.subLotdataGridRef.current.instance().getSelectedRowsData();
                if (selectedRowsData && selectedRowsData.length > 0) {
                    subLotToUse = selectedRowsData[0];
                }
            }
            
            if (!subLotToUse) {
                alert(MESSAGES.EMPTY_SUBDETAILS, "Information");
                return;
            }
            
            setShowAutoCreateSubLotsPopup({Visible:true,RSubLot:subLotToUse.rSublot,SubLotCode:subLotToUse.sublotCode,SubDetailRowId:subLotToUse.rowid,TransactionType:props.formFields.TRANSACTIONTYPE,Stage:props.formFields.STAGE,ReceivingMethod:props.profile?.ReceivingmethodSublot,DuplicateSubLot:props.profile?.Duplicatesublot,DetailRowId:props.sourceId});
            return;
        }
        if (name === WmSubDetailOperations.EnterWeights) {
            // Modern-only: a pending cell edit would be clobbered by the out-of-band PUT + refresh.
            const grid = props.subLotdataGridRef?.current?.instance?.();
            if (grid && grid.hasEditData()) {
                alert(MESSAGES.SAVE_OR_CANCEL_DETAIL_FIRST, MESSAGES.INFORMATION);
                return;
            }
            // State can lag grid selection; same fallback the AutoCreateSubLots branch above uses.
            let row = selectedSubLot;
            if (!row && grid) {
                const selectedRowsData = grid.getSelectedRowsData();
                if (selectedRowsData && selectedRowsData.length > 0) row = selectedRowsData[0];
            }
            if (!row) {
                alert(MESSAGES.SUBLOT_ROW_REQUIRED, MESSAGES.INFORMATION);
                return;
            }
            // uWMD0002.pas:14723-14727 - the only pre-condition Delphi placed on this option.
            if (!row.sublotCode) {
                alert(MESSAGES.SUBLOT_CODE_REQUIRED, MESSAGES.INFORMATION);
                return;
            }
            // uWMD0002.pas:17871-17873 (mnuSubLotReceiptsOptionsPopup). Delphi applies this to all
            // ten options on the popup; scoped to this branch so the diff stays attributable.
            if ((props.profile?.Uselocation === UseLocation.Yes || props.profile?.Uselocation === UseLocation.YesWithWarning) &&
                props.locationDataGridRef?.current?.instance?.()?.hasEditData()) {
                alert(MESSAGES.SAVE_LOCATION_RECORDS_FIRST, MESSAGES.ERROR);
                return;
            }
            // Modern-only, and a deliberate divergence: Delphi wrote QUANTITYACTUAL unconditionally.
            if (row.isDisableActual) {
                alert(MESSAGES.SUBLOT_ACTUAL_DERIVED_FROM_LOCATIONS, MESSAGES.INFORMATION);
                return;
            }
            setEnterWeightsPopup({visible:true,subDetail:row});
            return;
        }
        if( name === WmSubDetailOperations.UpdateTotalWeight){
            setUpdateTotalWeightPopup({visible:true,subDetail:selectedSubLot});
            return;
        }
        if(name === WmSubDetailOperations.ShowSerialNumber){
            setSerialNumberScreen(true);
            return;
        }
        if(name === WmSubDetailOperations.AutoSelectLocation){
            props.openAutoSelectLocationsPopup();
            return;
        }

    }

    const handleManuallySelectSublotForShipmentSave = () => {
        setTimeout(() => {
            props.RefereshGrid();
            // Delphi recalculates the transaction totals on return from the modal
            // (uWMD0002.pas:14281, AB_WMD0002_RunCalculateTransactionTotals).
            if (props.changeTotals) {
                props.changeTotals();
            }
            if (props.locationDataGridRef.current?.instance) {
                props.locationDataGridRef.current.instance().refresh();
            }
            if (props.subLotdataGridRef.current?.instance) {
                props.subLotdataGridRef.current.instance().refresh();
            }
        }, 100);
        setManuallySelectSublotForShipment(false);
    }
    const subLotDataSource = useMemo(() => createStore({
        key: 'rowid',
        loadUrl: `${window._env_.REACT_APP_APIS}/${data.TransactionSubLot.GetSubLotDetailsUrl}`,
        // No loadParams: GetTransactionSubLotDetails takes only the [FromHeader] Key sent below and
        // returns the raw IQueryable, so it never reads them. The pair that used to sit here was dead
        // either way - it re-sent the detail id, and sorted on "identityId", which is not a field of
        // TransactionSubDetailDTO. Ordering comes from `orderby subDetails.Keysequence` in the service.
        insertUrl: `${window._env_.REACT_APP_APIS}/${data.TransactionSubLot.InsertSubLotDetailsUrl}`,
        updateUrl: `${window._env_.REACT_APP_APIS}/${data.TransactionSubLot.UpdateSubLotDetailsUrl}`,
        onBeforeSend: function (method, ajaxOptions) {
            ajaxOptions.headers = {
                Authorization: `Bearer ${accessToken}`,
                Key: props.sourceId,
            };
        },
        onUpdated: function (key, updatedValues) {
            setTimeout(() => {
                props.RefereshGrid();
            }, 100);
            if ('quantityactual' in updatedValues) {
                if (props.locationDataGridRef.current?.instance) {
                    props.locationDataGridRef.current.instance().refresh();
                }
            }
        },
        onInserted: function (e) {
            // e is the insert response body (devextreme-aspnet-data resolves the deferred with it), so
            // rowid is the key the server wrote. This grid is deliberately NOT refreshed: refreshMode
            // "repaint" patches the new row in place from that response, so a reload here would be a
            // redundant GET per insert.
            //
            // RefereshGrid() is the PARENT detail grid, which is a different grid and does need it -
            // AddTransactionSubDetails rolls the sublot sums into WMTRANSACTIONDETAIL.QUANTITYORDER /
            // QUANTITYACTUAL, so the detail row's totals are stale until it reloads. Unconditional
            // because reaching here at all means the insert succeeded: a failure rejects the deferred
            // and onInserted never runs.
            setTimeout(() => {
                if (e?.rowid && props.subLotdataGridRef.current?.instance) {
                    props.subLotdataGridRef.current.instance().selectRows([e.rowid], false);
                }
                props.RefereshGrid();
            }, 100);
        }

    }), [props.sourceId]);
    const subLotdeleteRecords = useCallback(() => {
        var deleteUrl = "wm/TransactionSubLot/DeleteTransactionSubDetails";
        let result = confirm("<i>Are your sure you want to delete the selected record?</i>", "Delete");
        result.then((dialogResult) => {
            if (dialogResult) {
                axios.post(
                    `${window._env_.REACT_APP_APIS}/${deleteUrl}`,
                    selectedSublotKeys,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            access_token: accessToken,
                        },
                    }
                )
                    .then((res) => {
                        if (props.subLotdataGridRef.current && props.subLotdataGridRef.current.instance) {
                            props.subLotdataGridRef.current.instance().refresh();
                        }
                        setTimeout(() => {
                            props.RefereshGrid();
                        }, 100);
                    })
                    .catch((err) => {
                    });
            }
        });
    }, [selectedSublotKeys]);
    const handleSubLotCellValueChanged = (data) => {
        const newKeys = data.selectedRowKeys;
        const row = data.selectedRowsData[0];
        if (row) {
            props.setSelectedSubLot(row);
            setSelectedSubLot(row);
        }
        if (
            newKeys.length !== selectedSublotKeys.length ||
            newKeys[0] !== selectedSublotKeys[0]
        ) {
            setSelectedSublotKeys(newKeys);
        }
    }
    const onSubLotInitNewRow = (e) => {
        if (e.component._sLot) {
            e.data.sublotCode = e.component._sLot.SubLotCode;
            delete e.component._sLot;
        }
    };
    // Delphi RunCommonSubDetailScroll (uWMD0002.pas:6903-6940) disables the sublot Actual editor on two
    // conditions: the stage is P/F/N, or the sublot has more than one location row (Actual is then derived
    // from the location totals). Only the second half was ported - isDisableActual, computed server-side
    // as LocationCount > 1 - so Actual stayed typeable at the pending stages, where it is not a maintained
    // quantity. Same expression as the detail grid's own gate at DetailsTab.js:2174.
    const isPendingStage = () => [TransactionStage.Plan, TransactionStage.Future, TransactionStage.Pending]
        .includes(props.formFields?.STAGE);

    // Not the complement of isPendingStage: Delphi disables the editor at P/F/N and defaults the value at
    // R/C, and Assigned ('A') / Picked ('S') fall outside both sets. Mirrors the server-side gate in
    // TransactionSubLotQuantityRules and the same rule as EnterWeights.js:79-81.
    const stageMaintainsActual = () => props.formFields?.STAGE === TransactionStage.Ready
        || props.formFields?.STAGE === TransactionStage.Completed;

    const onSublotEditingStart = (e) => {
        const field = e.column.dataField;
        const row = e.data;
        if (field === 'quantityactual' && (row.isDisableActual || isPendingStage())) {
            e.cancel = true;
        }
        if (e.key != null && e.key != undefined && !props.subLotdataGridRef.current.instance().isRowSelected(e.key)) {
            props.subLotdataGridRef.current.instance().selectRows([e.key], false);
        }
    };
    const onSubLotContentReady = (e) => {

        if (preventAutoSelect) {
            setPreventAutoSelect(false);
            return;
        }
        if (!e.component._hasLoaded) {
            var selection = e.component.getSelectedRowKeys();
            if (selection.length == 0) {
                e.component.selectRowsByIndexes([0]);
            }
        }
    };
    const isValidGuid = (guid) => {
        const guidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/;
        return guidRegex.test(guid);
    };
    const rowSubLotInserting = (e) => {
        e.data['rTransactiondetail'] = props.sourceId;
    }

    const rowSubLotUpdating = (e) => {
        if (!e.newData.hasOwnProperty('sublotCode')) {
            e.newData['sublotCode'] = e.oldData['sublotCode'];
        }
    }

    const locationDataSource = useMemo(() => {
        const selectedKey = selectedSublotKeys?.[0];
        return createStore({
            key: 'rowid',
            loadUrl: `${window._env_.REACT_APP_APIS}/${data.TransactionSubLot.GetSubLotLocationUrl}`,
            insertUrl: `${window._env_.REACT_APP_APIS}/${data.TransactionSubLot.InsertSubLotLocationUrl}`,
            updateUrl: `${window._env_.REACT_APP_APIS}/${data.TransactionSubLot.UpdateSubLotLocationUrl}`,
            loadParams: {
                detailId: props.sourceId
            },
            onBeforeSend: function (method, ajaxOptions) {
                ajaxOptions.headers = {
                    Authorization: `Bearer ${accessToken}`,
                    Key: isValidGuid(selectedKey) ? selectedKey : EMPTY_GUID
                };
            },
            onUpdated: function (key, updatedValues) {

                if ('inReceiving' in updatedValues) {
                    props.RefereshGrid()
                    if (props.subLotdataGridRef.current?.instance) {
                        props.subLotdataGridRef.current.instance().refresh();
                    }
                }
            },
            onInserted: function (e) {
                setTimeout(() => {
                    if (props.subLotdataGridRef.current?.instance) {
                        props.subLotdataGridRef.current.instance().refresh();
                    }
                    props.RefereshGrid();
                }, 100);
            }
        });
    }, [selectedSublotKeys]);
    const handleLocationCellValueChanged = (data) => {
        setSelectedLocationKeys(data.selectedRowKeys);
    }
    const onLocationInitNewRow = (e) => {
        if (!e.data.availableflag) {
            e.data.availableflag = "Y";
            e.data.availableflagDiscription = "Yes";;
        }
    };
    const onLocationEditingStart = (e) => {
        if (e.key != null && e.key != undefined && !props.locationDataGridRef.current.instance().isRowSelected(e.key)) {
            props.locationDataGridRef.current.instance().selectRows([e.key], false);
        }
    };
    const onLocationContentReady = (e) => {
        if (!e.component._hasLoaded) {
            e.component._hasLoaded = true;
            var selection = e.component.getSelectedRowKeys();
            if (selection.length == 0) {
                e.component.selectRowsByIndexes([0]);
            }
        }
    };
    const rowLocationInserting = (e) => {
        const sourceId = props?.sourceId;
        const subLotId = selectedSublotKeys ? selectedSublotKeys[0] : null;
        if (!subLotId) {
            notify(
                {
                    message: "Cannot insert row: Please Select Sublot",
                    width: 100,
                },
                'error',
                3000,
            );
            e.cancel = true;
            return;
        }
        e.data.rTransactiondetail = sourceId;
        e.data.rTransactionsubdetail = subLotId;
    }
    const renderCode1Cell = (cellElement) => {
        const currentValue = cellElement.row.data?.comment || '';
        return (
            <TextArea
                defaultValue={currentValue}
                onValueChanged={(e) => {
                    cellElement.setValue(e.value);
                    comment = e.value;
                }}
                label="."
                labelMode='static'
                stylingMode='outlined'
                onKeyDown={async (e) => {
                    if (e.event.key == "Enter") {
                        e.event.stopPropagation();
                    }
                }}
            >
            </TextArea>
        );
    }
    async function setStateValue3(rowData, value) {
        try {
            if (availableFlag == "Y") {
                rowData.availablereasoncode = "";
            }
            rowData.availableflag = availableFlag;
            rowData.availableflagDiscription = value;

        } catch (error) {
            console.error("Failed to fetch item data:", error);
        }
    }
    const renderCell = (cellElement) => {
        const items = [{ "id": "Y", "name": "Yes" },
        { "id": "N", "name": "No" },
        ];
        const currentValue = cellElement.row.data.availableflag;
        return (
            <SelectBox
                dataSource={items}
                valueExpr="id"
                displayExpr="name"
                defaultValue={currentValue}
                acceptCustomValue={true}
                searchEnabled={false}
                searchMode="contains"
                showClearButton={false}
                searchExpr="name"
                onValueChanged={(e) => {
                    const selectedText = e.component.option('displayValue');
                    availableFlag = e.value;
                    cellElement.setValue(selectedText);
                    if (availableFlag === Options.No) {
                        const grid = cellElement.component;
                        grid.editCell(cellElement.rowIndex, "availablereasoncode");
                    }
                }}
            />
        );
    }
    const deleteLocationRecords = useCallback(() => {
        var deleteUrl = "wm/TransactionSubLot/TransactionSubDetaillocation";
        let result = confirm("<i>Are your sure you want to delete selected records?</i>", "Delete");
        result.then((dialogResult) => {
            if (dialogResult) {
                axios.post(
                    `${window._env_.REACT_APP_APIS}/${deleteUrl}`,
                    selectedLocationKeys,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            access_token: accessToken,
                        },
                    }
                )
                    .then((res) => {
                        props.RefereshGrid()
                        if (props.subLotdataGridRef.current?.instance) {
                            props.subLotdataGridRef.current.instance().refresh();
                        }
                        if (props.locationDataGridRef.current?.instance) {
                            props.locationDataGridRef.current.instance().refresh();
                        }
                    })
                    .catch((err) => {
                        if (props.locationDataGridRef.current && props.locationDataGridRef.current.instance) {
                            props.locationDataGridRef.current.instance().endCustomLoading();
                        }
                    });
            }
        });
    }, [selectedLocationKeys]);
    const validationsubCanceled = useRef(false);

    const ValidateTransactionSubDetailWarning = (e) => {

        var duplicatesublotProfileSetting = props.profile?.Duplicatesublot;
        if (!duplicatesublotProfileSetting || !['W'].includes(duplicatesublotProfileSetting)) {
            return;
        }
        if (validationsubCanceled.current) {
            validationsubCanceled.current = false;
            e.isValid = false;
            e.cancel = true;
            return;
        }
        const lot = e.newData?.sublotCode?.trim() ?? e.oldData?.sublotCode?.trim();

        e.promise = new Promise(async (resolve) => {

            const payload = {
                headerId: props.headerId,
                subLotCode: lot,
            };
            try {
                const res = await axios.post(
                    `${window._env_.REACT_APP_APIS}/wm/TransactionSubLot/ValidateTransactionSubDetailWarning`,
                    payload,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            access_token: accessToken,
                        },
                    }
                );
                if (res.data.issuccess) {
                    return resolve();
                }
                if (res.data.iswarning) {
                    const warningText = formatErrorList(res.data.errors, ERROR_SEVERITY.WARNING) || "Confirm";
                    confirm(warningText, "Confirm").done(result => {
                        if (!result) {
                            e.isValid = false;
                            e.errorText = warningText;
                            validationsubCanceled.current = true;
                            setTimeout(() => {
                                const gridInstance = e.component;
                                gridInstance.cancelEditData();
                            });
                        } else {
                            e.isValid = true;
                        }
                        resolve();
                    });
                } else {
                    const errorText = formatErrorList(res.data.errors, ERROR_SEVERITY.ERROR);
                    e.isValid = false;
                    alert(errorText);
                    e.errorText = errorText;
                    validationsubCanceled.current = true;
                    setTimeout(() => {
                        const gridInstance = e.component;
                        gridInstance.cancelEditData();
                    });
                    resolve();
                }

            } catch (error) {
                console.error("Validation error:", error);
                e.isValid = false;
                e.errorText = "Server validation error.";
                resolve();
            }
        });
    };
    const runSubLotProfileLogics = async () => {
        try {
            var receivingMethodSubLot = props.profile?.ReceivingmethodSublot;
            var showMasterSubLot = props.profile?.ShowmasterSublot;
            let lotId = props.selectedLotRowId;
            if (receivingMethodSubLot !== ReceivingMethodSubLot.Manual)
                setLoadPanelVisible(true);
            if (receivingMethodSubLot == ReceivingMethodSubLot.Manual) {
                //The Lot Code field will be enabled and will be manually entered
            }
            else if (receivingMethodSubLot == ReceivingMethodSubLot.Sequential) {
                //The Lot Code field will be enabled and will be manually entered
            }
            else if (receivingMethodSubLot == ReceivingMethodSubLot.Unit) {
                //Get sublot by Lot and sublot cell will be disabled
            }
            if (showMasterSubLot == ShowMasterSubLot.None) {
                //No screen opens
            }
            else if (receivingMethodSubLot == ReceivingMethodSubLot.Sequential && showMasterSubLot == ShowMasterSubLot.Yes) {
                //open Main Window
                let subLotCode = await getNextTransNumber();
                let params = {
                    LotRowId: lotId,
                    SublotCode: subLotCode
                };
                let subLot = await getSubLotById(params);
                if (!subLot || !subLot.SubLotId) {
                    subLot = await insertSubLot(lotId, subLotCode);
                }
                if (subLot && subLot.SubLotId)
                    setSubLotId(subLot.SubLotId);
                return subLot;
            }
            else if (showMasterSubLot == ShowMasterSubLot.Auto) {
                //Open WMD0083
            }
            else if (showMasterSubLot == ShowMasterSubLot.QuickEntry) {
                //Open SubLot Quick Entry Screen
            }

            if (sublotMethod === MethodShipments.AutoSelect && props.selectedDetails?.itemType === ItemTypes.SubLot) {
                // open WMD0108 
                return;
            }
            else if (sublotMethod === MethodShipments.AutoDefault && props.selectedDetails?.itemType === ItemTypes.SubLot) {
                let params = {
                    LotRowId: lotId,
                    IsAvaiable: true,
                    OrderBy: getKeyByValue(SublotPickMethodShipments, sublotPickMethod),
                    IsDescendingOrder: sublotPickSeqMethod === PickSequence.Descending
                };
                let subLot = await getSubLotById(params);
                return subLot;
            }
        } catch (error) {
            console.error("Error in runSubLotProfileLogics:", error);
        }
        finally {
            setLoadPanelVisible(false);
        }

    }
    useEffect(() => {
        if (subLotId) {
            setShowSubLotEntryScreen(true);
        }
    }, [subLotId]);
    const runUnitProfileLogics = () => {
        var receivingMethodUnit = props.profile?.RECEIVINGMETHOD_UNIT;
        var showMasterUnit = props.profile?.SHOWMASTER_UNIT;
        if (receivingMethodUnit == ReceivingMethodUnit.Sequential) {
            //Sequential Entry
            //unit field disabled
        }
        else if (receivingMethodUnit == ReceivingMethodUnit.Manual) {
            //unit field enabled
        }

        if (showMasterUnit == ShowMasterUnit.Yes) {
        }
        else if (showMasterUnit == ShowMasterUnit.None) {
        }
    }
    const getNextTransNumber = async () => {
        try {
            const response = await axios.get(
                `${window._env_.REACT_APP_APIS}/${data.AB.GetTransactionNo}`,
                {
                    params: {
                        Module: WM,
                        TransactionType: TransactionTypes.SubLot,
                    },
                    headers: {
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            return response.data;
        } catch (error) {
            console.error(MESSAGES.FETCH_ERROR, error);
            throw error;
        }
    };
    const getSubLotById = async (params) => {
        try {
            const response = await axios.get(`${window._env_.REACT_APP_APIS}/${data.SubLot.GetSublot}`, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
                params
            });
            if (response.data) {
                let lot = {
                    SubLotCode: response.data.subLotCode,
                    SubLotId: response.data.rowId,
                };
                return lot;
            }
            return null;
        } catch (error) {
            console.error(MESSAGES.FETCH_ERROR, error);
        }
    };
    const insertSubLot = async (lotId, sLotCode) => {

        try {
            let fields = {
                R_LOT: lotId,
                SUBLOTCODE: sLotCode,
            };

            const response = await axios.post(`${window._env_.REACT_APP_APIS}/${data.SubLot.InsertSublot}`, fields, {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            if (response.data) {
                let lot = {
                    SubLotCode: sLotCode,
                    SubLotId: response.data.ROWID,
                };
                return lot;
            }

            return null;
        } catch (error) {
            console.error(error);
            return null; // ✅ always return something
        }
    };

 

    return (
        <div className="row">
            <LoadPanel
                shadingColor="rgba(0,0,0,0.4)"
                position={position}
                onHiding={() => setLoadPanelVisible(false)}
                visible={loadPanelVisible}
                showIndicator={true}
                shading={true}
                showPane={true}
                hideOnOutsideClick={false}
            />
            <div className="col-md-6">
                <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                    id="gridSubLotContainer"
                    dataSource={subLotDataSource}
                    ref={props.subLotdataGridRef}
                    selectedRowKeys={selectedSublotKeys}
                    showBorders={true}
                    rowAlternationEnabled={true}
                    allowColumnReordering={true}
                    allowColumnResizing={true}
                    columnAutoWidth={true}
                    onSelectionChanged={handleSubLotCellValueChanged}
                    onInitNewRow={onSubLotInitNewRow}
                    height={BOTTOM_GRID_HEIGHT}
                    onEditingStart={onSublotEditingStart}
                    onContentReady={onSubLotContentReady}
                    onRowInserting={rowSubLotInserting}
                    onRowValidating={ValidateTransactionSubDetailWarning}
                    onRowUpdating={rowSubLotUpdating}
                    onToolbarPreparing={(e) => {
                        const addNewRowButton = e.toolbarOptions.items.find(item => item.name === DevextremeEnums.AddRowButton);
                        if (addNewRowButton) {
                            // Store the original click handler if you need to call it later
                            const originalOnClick = addNewRowButton.options.onClick;
                            addNewRowButton.options.onClick = async function () {
                                let sLot = await runSubLotProfileLogics();
                                if (sLot) {
                                    e.component._sLot = sLot;
                                }
                                e.component.addRow();
                                const grid = e.component;
                                grid.editCell(0, "quantityorder");
                            };
                        }
                    }}
                >
                    <ColumnChooser
                        enabled={true}
                        title="Choose Column"
                        width={290}
                        height={290}
                        sortOrder="asc"
                    >
                        <ColumnChooserSearch
                            enabled={true}
                            editorOptions={{ placeholder: 'Search column' }} />
                    </ColumnChooser>
                    <StateStoring
                        enabled={true}
                        type="custom"
                        customLoad={loadSubLotState}
                        storageKey={subLotGridKey}
                        customSave={saveSubLotState}
                    />
                    <Scrolling mode="standard" />
                    <Selection mode="single" />
                    <Export enabled={true} allowExportSelectedData={true} />
                    <Editing
                        mode="cell"
                        refreshMode="repaint"
                        allowUpdating={!props.disableGridsForRFTransactions && !props.isCommittedTransaction}
                        allowAdding={!props.disableGridsForRFTransactions && !props.isCommittedTransaction}
                    />

                    <FilterRow visible={true} />
                    <Column dataField="keySequence" caption='Key Sequence' visible={false} allowSorting={false} showInColumnChooser={false} />
                    <Column dataField="rowid" caption='rowid' visible={false} allowSorting={false} showInColumnChooser={false}   >
                    </Column>
                    <Column dataField="sublotCode" caption="Sublot" allowSorting={false}
                        editCellRender={(cellElement) =>
                            RenderSelectBoxCell({
                                loadUrl: `${window._env_.REACT_APP_APIS}/wm/TransactionSubLot/GetTransactionSubLots`,
                                loadParams: {
                                    detailId: function () {
                                        return props.sourceId;
                                    }
                                },
                                key: "id",
                                displayExpr: "name",
                                valueExpr: "id",
                                acceptCustomValue: "true",
                                accessToken: accessToken,
                                defaultValue: cellElement.data.rSublot,
                                sort: [{ selector: "name", desc: false }],

                                onValueChangeCallback: (value, text, additionalData) => {
                                    // Key must be `value`: setCellValue below reads newValue.value, so the
                                    // shorthand { finalValue, ... } left rowData.rSublot undefined on every
                                    // pick and blanked the editor's defaultValue on re-entry.
                                    const finalValue = isValidGuid(value) ? value : EMPTY_GUID;
                                    cellElement.setValue({ value: finalValue, text, additionalData });
                                },
                            })
                        }
                        setCellValue={(rowData, newValue) => {
                            rowData.rSublot = newValue.value;
                            rowData.sublotCode = newValue.text;
                        }}
                    > <RequiredRule message={"Sublot is required."}></RequiredRule></Column>
                    <Column dataField="quantityorder" caption="Ordered" dataType="number" format="#,##0.00" allowSorting={false}
                        setCellValue={(newData, value, currentRowData) => {
                            newData.quantityorder = value;

                            // Delphi qryWMTransactionSubDetailQUANTITYORDERChange (uWMM0002.PAS:7146-7153):
                            // Ordered seeds Actual on insert only, at stage R/C only. The == null test is
                            // Delphi's `= 0` guard - never clobber a figure the operator already typed.
                            // The server applies the same rule and is the authority; this is here so the
                            // value shows before the round-trip rather than appearing a beat later.
                            const isInsert = !currentRowData?.rowid || currentRowData.rowid === EMPTY_GUID;

                            if (isInsert && stageMaintainsActual() && currentRowData?.quantityactual == null) {
                                newData.quantityactual = value;
                            }
                        }}
                    />
                    <Column
                        dataField="quantityactual"
                        caption="Actual"
                        dataType="number"
                        format="#,##0.00"
                        allowSorting={false}
                        cellRender={(cellData) => {
                            // Greyed on both halves of the Delphi rule, so a cell that onEditingStart
                            // refuses to open looks read-only instead of merely unresponsive.
                            const isDisabled = cellData.data.isDisableActual || isPendingStage();
                            return (
                                <div style={{ color: isDisabled ? '#999' : 'inherit' }}>
                                    {cellData.text}
                                </div>
                            );
                        }}
                    />
                    <Column  visible={false}  dataField="consignee" caption="Consignee" allowSorting={false}
                        editCellRender={(cellElement) =>
                            RenderSelectBoxCell({
                                loadUrl: `${window._env_.REACT_APP_APIS}/id/Lookup/GetConsignees`,
                                key: "id",
                                displayExpr: "name",
                                valueExpr: "id",
                                acceptCustomValue: "true",
                                accessToken: accessToken,
                                defaultValue: cellElement.data.rConsignee,
                                sort: [{ selector: "name", desc: false }],
                                onValueChangeCallback: (value, text, additionalData) => {
                                    cellElement.setValue(({ value, text, additionalData }));
                                },
                            })
                        }
                        setCellValue={(rowData, newValue) => {
                            rowData.rConsignee = newValue.value;
                            rowData.consignee = newValue.text;
                        }}
                    > </Column>
                    <Column  visible={false}  dataField="userDefinedCode1" caption="Code-1" dataType="string" allowSorting={false}
                        editCellRender={cellElement => {
                            return RenderSelectBoxCell({
                                loadUrl: `${window._env_.REACT_APP_APIS}/wm/Lookup/GetCodes`,
                                loadParams: { codeType: "18" },
                                key: "name",
                                displayExpr: "name",
                                valueExpr: "name",
                                accessToken,
                                sort: [{ selector: "name", desc: false }],
                                defaultValue: cellElement.data.userDefinedCode1,
                                onValueChangeCallback: (value, text) => {
                                    cellElement.setValue({ value, text });
                                },
                            });
                        }}
                        setCellValue={(rowData, newValue) => {
                            rowData.userDefinedCode1 = newValue.text;
                        }}
                    ></Column>
                    <Column  visible={false}  dataField="userDefinedCode2" caption="Code-2" dataType="string" allowSorting={false}
                        editCellRender={cellElement => {
                            return RenderSelectBoxCell({
                                loadUrl: `${window._env_.REACT_APP_APIS}/wm/Lookup/GetCodes`,
                                loadParams: { codeType: "19" },
                                key: "name",
                                displayExpr: "name",
                                valueExpr: "name",
                                accessToken,
                                sort: [{ selector: "name", desc: false }],
                                defaultValue: cellElement.data.userDefinedCode2,
                                onValueChangeCallback: (value, text) => {
                                    cellElement.setValue({ value, text });
                                },
                            });
                        }}
                        setCellValue={(rowData, newValue) => {
                            rowData.userDefinedCode2 = newValue.text;
                        }}
                    ></Column>
                    <Column  visible={false}  dataField="userDefinedCode3" caption="Code-3" dataType="string" allowSorting={false}
                        editCellRender={cellElement => {
                            return RenderSelectBoxCell({
                                loadUrl: `${window._env_.REACT_APP_APIS}/wm/Lookup/GetCodes`,
                                loadParams: { codeType: "20" },
                                key: "name",
                                displayExpr: "name",
                                valueExpr: "name",
                                accessToken,
                                sort: [{ selector: "name", desc: false }],
                                defaultValue: cellElement.data.userDefinedCode3,
                                onValueChangeCallback: (value, text) => {
                                    cellElement.setValue({ value, text });
                                },
                            });
                        }}
                        setCellValue={(rowData, newValue) => {
                            rowData.userDefinedCode3 = newValue.text;
                        }}
                    ></Column>
                    <Column  visible={false}  dataField="userDefinedCode4" caption="Code-4" dataType="string" allowSorting={false}
                        editCellRender={cellElement => {
                            return RenderSelectBoxCell({
                                loadUrl: `${window._env_.REACT_APP_APIS}/wm/Lookup/GetCodes`,
                                loadParams: { codeType: "21" },
                                key: "name",
                                displayExpr: "name",
                                valueExpr: "name",
                                accessToken,
                                sort: [{ selector: "name", desc: false }],
                                defaultValue: cellElement.data.userDefinedCode4,
                                onValueChangeCallback: (value, text) => {
                                    cellElement.setValue({ value, text });
                                },
                            });
                        }}
                        setCellValue={(rowData, newValue) => {
                            rowData.userDefinedCode4 = newValue.text;
                        }}
                    ></Column>
                    <Column  visible={false}  dataField="userDefinedCode5" caption="Code-5" dataType="string" allowSorting={false}
                        editCellRender={cellElement => {
                            return RenderSelectBoxCell({
                                loadUrl: `${window._env_.REACT_APP_APIS}/wm/Lookup/GetCodes`,
                                loadParams: { codeType: "22" },
                                key: "name",
                                displayExpr: "name",
                                valueExpr: "name",
                                accessToken,
                                sort: [{ selector: "name", desc: false }],
                                defaultValue: cellElement.data.userDefinedCode5,
                                onValueChangeCallback: (value, text) => {
                                    cellElement.setValue({ value, text });
                                },
                            });
                        }}
                        setCellValue={(rowData, newValue) => {
                            rowData.userDefinedCode5 = newValue.text;
                        }}
                    ></Column>
                    <Column  visible={false}  dataField="userDefinedCode6" caption="Code-6" dataType="string" allowSorting={false}
                        editCellRender={cellElement => {
                            return RenderSelectBoxCell({
                                loadUrl: `${window._env_.REACT_APP_APIS}/wm/Lookup/GetCodes`,
                                loadParams: { codeType: "23" },
                                key: "name",
                                displayExpr: "name",
                                valueExpr: "name",
                                accessToken,
                                sort: [{ selector: "name", desc: false }],
                                defaultValue: cellElement.data.userDefinedCode6,
                                onValueChangeCallback: (value, text) => {
                                    cellElement.setValue({ value, text });
                                },
                            });
                        }}
                        setCellValue={(rowData, newValue) => {
                            rowData.userDefinedCode6 = newValue.text;
                        }}
                    ></Column>
                    <Column  visible={false}  dataField="userDefinedCode7" caption="Code-7" dataType="string" allowSorting={false}
                        editCellRender={cellElement => {
                            return RenderSelectBoxCell({
                                loadUrl: `${window._env_.REACT_APP_APIS}/wm/Lookup/GetCodes`,
                                loadParams: { codeType: "24" },
                                key: "name",
                                displayExpr: "name",
                                valueExpr: "name",
                                accessToken,
                                sort: [{ selector: "name", desc: false }],
                                defaultValue: cellElement.data.userDefinedCode7,
                                onValueChangeCallback: (value, text) => {
                                    cellElement.setValue({ value, text });
                                },
                            });
                        }}
                        setCellValue={(rowData, newValue) => {
                            rowData.userDefinedCode7 = newValue.text;
                        }}
                    ></Column>
                    <Column visible={false} dataType="number" dataField="userDefinedQuantity1" caption="Quantity 1" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                    <Column visible={false} dataType="number" dataField="userDefinedQuantity2" caption="Quantity 2" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                    <Column visible={false} dataType="number" dataField="userDefinedQuantity3" caption="Quantity 3" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                    <Column visible={false} dataType="number" dataField="userDefinedQuantity4" caption="Quantity 4" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                    <Column visible={false} dataType="number" dataField="userDefinedQuantity5" caption="Quantity 5" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                    <Column visible={false} dataType="number" dataField="userDefinedQuantity6" caption="Quantity 6" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                    <Column visible={false} dataType="number" dataField="userDefinedQuantity7" caption="Quantity 7" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                    <Column visible={false} dataType="number" dataField="userDefinedQuantity8" caption="Quantity 8" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                    <Column visible={false} dataType="string" dataField="userDefinedReference1" caption="Reference 1"   editorOptions={{ maxLength: 20 }}/>
                    <Column visible={false} dataType="string" dataField="userDefinedReference2" caption="Reference 2"   editorOptions={{ maxLength: 20 }}/>
                    <Column visible={false} dataType="string" dataField="userDefinedReference3" caption="Reference 3"   editorOptions={{ maxLength: 20 }}/>
                    <Column visible={false} dataType="string" dataField="userDefinedReference4" caption="Reference 4"   editorOptions={{ maxLength: 20 }}/>
                    <Column visible={false} dataType="string" dataField="userDefinedReference5" caption="Reference 5"   editorOptions={{ maxLength: 20 }}/>
                    <Column visible={false} dataType="string" dataField="userDefinedReference6" caption="Reference 6"   editorOptions={{ maxLength: 20 }}/>
                    <Column visible={false} dataType="string" dataField="userDefinedReference7" caption="Reference 7"   editorOptions={{ maxLength: 20 }}/>
                    <Column visible={false} dataType="string" dataField="userDefinedReference8" caption="Reference 8"  editorOptions={{ maxLength: 20 }} />
                    <Column visible={false} dataType="number" allowEditing={false} dataField="netweight" caption="Net Weight" format={{ type: 'fixedPoint', precision: 4, useGrouping: true }} editorOptions={{ format: { type: 'fixedPoint', precision: 4, useGrouping: true } }}/>
                    <Column visible={false} dataType="number" allowEditing={false} dataField="grossweight" caption="Gross Weight" format={{ type: 'fixedPoint', precision: 4, useGrouping: true }} editorOptions={{ format: { type: 'fixedPoint', precision: 4, useGrouping: true } }}/>
                    <Column visible={false} dataType="number" allowEditing={false} dataField="unitWeight" caption="Unit Weight" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}/>
                    <Toolbar>
                        <Item
                            name="addRowButton"
                        />
                        <Item location="after">
                            <Button
                                onClick={subLotdeleteRecords}
                                icon="trash"
                                disabled={!selectedSublotKeys.length || props.disableGridsForRFTransactions === true || props.isCommittedTransaction == true}
                            />
                        </Item>
                        <Item location="after">
                            <DropDownButton
                                icon="fa fa-cogs"
                                stylingMode="text"
                                items={items}
                                dropDownOptions={{ width: 'auto', minWidth: 320 }}
                                displayExpr="name"
                                onItemClick={onItemClick}
                            />
                        </Item>
                        <Item location="after">
                            <div className="separator"></div>
                        </Item> 
                        <Item location="after">
                            <GridLayoutManager gridKey={subLotGridKey} dataGrid={props.subLotdataGridRef} setCurrentLayout={setSubLotCurrentLayout} />
                        </Item>
                        <Item name="exportButton" />
                        <Item name="columnChooserButton" />
                    </Toolbar>
                </DataGrid>
            </div>
            {(props.profile?.Uselocation !== 'N') && (
                <div className="col-md-6">
                    <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                        id="gridContainer"
                        dataSource={locationDataSource}
                        ref={props.locationDataGridRef}
                        selectedRowKeys={selectedLocationKeys}
                        showBorders={true}
                        rowAlternationEnabled={true}
                        allowColumnReordering={true}
                        allowColumnResizing={true}
                        columnAutoWidth={true}
                        onSelectionChanged={handleLocationCellValueChanged}
                        onInitNewRow={onLocationInitNewRow}
                        height={BOTTOM_GRID_HEIGHT}
                        onEditingStart={onLocationEditingStart}
                        onContentReady={onLocationContentReady}
                        onRowInserting={rowLocationInserting}
                    >
                        <ColumnChooser
                            enabled={true}
                            title="Choose Column"
                            width={290}
                            height={290}
                            sortOrder="asc"
                        >
                            <ColumnChooserSearch
                                enabled={true}
                                editorOptions={{ placeholder: 'Search column' }} />
                        </ColumnChooser>
                        <StateStoring
                            enabled={true}
                            type="custom"
                            customLoad={loadLocationState}
                            storageKey={gridLocationKey}
                            customSave={saveLocationState}
                        />
                        <Scrolling mode="standard" />
                        <Selection mode="single" />
                        <Export enabled={true} allowExportSelectedData={true} />
                        <Editing
                            mode="cell"
                            refreshMode="repaint"
                            allowUpdating={!props.disableGridsForRFTransactions && !props.isCommittedTransaction}
                            allowAdding={!props.disableGridsForRFTransactions && !props.isCommittedTransaction}
                        />

                        <FilterRow visible={true} />
                        <Column dataField="keySequence" caption='Key Sequence' visible={false} allowSorting={false} showInColumnChooser={false} />
                        <Column dataField="rowid" caption='rowid' visible={false} allowSorting={false} showInColumnChooser={false}   >
                        </Column>
                        <Column dataField="warehouse" caption="Warehouse" allowSorting={false}
                            editCellRender={(cellElement) =>
                                RenderSelectBoxCell({
                                    loadUrl: `${window._env_.REACT_APP_APIS}/id/Lookup/GetWarehouses`,
                                    key: "id",
                                    displayExpr: "name",
                                    valueExpr: "id",
                                    accessToken: accessToken,
                                    defaultValue: cellElement.data.rWarehouse,
                                    sort: [{ selector: "name", desc: false }],
                                    onValueChangeCallback: (value, text, additionalData) => {
                                        cellElement.setValue(({ value, text, additionalData }));
                                    },
                                })
                            }
                            setCellValue={(rowData, newValue) => {
                                rowData.rWarehouse = newValue.value;
                                rowData.warehouse = newValue.text;
                            }}
                        ></Column>
                        <Column dataField="location" caption="Location" allowSorting={false}
                            editCellRender={(cellElement) =>
                                RenderSelectBoxCell({
                                    loadUrl: `${window._env_.REACT_APP_APIS}/im/Lookup/GetLocations`,
                                    key: "id",
                                    loadParams:
                                    {
                                        warehouseRowId: cellElement?.data?.rWarehouse || EMPTY_GUID,
                                        // WM transaction context -> Delphi's location criteria
                                        // (uWMD0002.pas:5998-6025 and SetCriteriaForLocationLookup :6028-6114).
                                        // Sent from the location ROW, not the parent props: Delphi reads the same
                                        // fields off qryIMTransactionLocation.
                                        transactionType: props.formFields?.TRANSACTIONTYPE ?? "",
                                        stage:           props.formFields?.STAGE ?? "",
                                        itemType:        props.selectedDetails?.itemType ?? "",
                                        itemId:          props.selectedItemRowId   || EMPTY_GUID,
                                        lotId:           props.selectedLotRowId    || EMPTY_GUID,
                                        sublotId:        function()
                                        {
                                            // Get selected sublot - check state first, then try to get from grid
                                            let subLotToUse = selectedSubLot;
                                            if (!subLotToUse && props.subLotdataGridRef.current?.instance) {
                                                const selectedRowsData = props.subLotdataGridRef.current.instance().getSelectedRowsData();
                                                if (selectedRowsData && selectedRowsData.length > 0) {
                                                    subLotToUse = selectedRowsData[0];
                                                }
                                            }
                                            
                                            if (!subLotToUse) {
                                                return EMPTY_GUID;
                                            }

                                            return subLotToUse.rSublot;

                                        },
                                        rowOutShipped:   Number(cellElement?.data?.outShipped ?? 0)
                                    },
                                    displayExpr: "name",
                                    valueExpr: "id",
                                    accessToken: accessToken,
                                    defaultValue: cellElement.data.rLocation,
                                    sort: [{ selector: "name", desc: false }],
                                    onValueChangeCallback: async (value, text, additionalData) => {
                                        // Reserve Location class rule, shared with the manual selection
                                        // screens so it cannot drift. Checked BEFORE the value is applied:
                                        // LOCATIONBYCLASS 'Y' refuses the location outright and 'W' refuses
                                        // it only if the user declines, the same outcome the selection
                                        // screens produce by un-ticking the row.
                                        if (additionalData) {
                                            const accepted = await checkLocationClassOnPick({
                                                itemClassCode: props.selectedDetails?.itemClasscode,
                                                itemSubClassCode: props.selectedDetails?.itemSubclasscode,
                                                locationClassCode: additionalData.classCode,
                                                locationSubClassCode: additionalData.subClassCode,
                                                locationByClass: props.profile?.Locationbyclass,
                                                transactionType: props.formFields?.TRANSACTIONTYPE,
                                            });
                                            if (!accepted) return;
                                        }
                                        cellElement.setValue({ value, text, additionalData });
                                    },
                                })
                            }
                            setCellValue={(rowData, newValue) => {
                                rowData.rLocation = newValue.value;
                                rowData.location = newValue.text;
                            }}
                        >
                            {props.profile?.Allowblanklocations !== 'Y' && (<RequiredRule message="A valid Location Must be Assigned" />)}
                        </Column>
                        {props?.formFields?.TRANSACTIONTYPE == TransactionTypes.Shipment && (
                            <Column dataField="outShipped" caption="Quantity" dataType="number" format="#,##0.00" allowSorting={false} />
                        )}
                        {props?.formFields?.TRANSACTIONTYPE != TransactionTypes.Shipment && (
                            <Column dataField="inReceiving" caption="Quantity" dataType="number" format="#,##0.00" allowSorting={false} />
                        )}
                        {/* Read-only for shipments: Delphi disables the Available editor for transaction
                            type S (uWMD0002.pas:6379-6381), because an outbound movement has no
                            available/unavailable choice to make - the quantity is leaving either way. */}
                        <Column dataField="availableflagDiscription" caption='Available' editCellRender={renderCell} setCellValue={setStateValue3} allowSorting={false}
                            allowEditing={props?.formFields?.TRANSACTIONTYPE !== TransactionTypes.Shipment}>
                        </Column>
                        <Column dataField="availablereasoncode" caption="Reason" dataType="string" allowSorting={false}
                            editCellRender={cellElement => {
                                const rowDisabled = cellElement.row.data.availableflag === "Y";
                                return RenderSelectBoxCell({
                                    loadUrl: `${window._env_.REACT_APP_APIS}/wm/Lookup/GetCodes`,
                                    loadParams: { codeType: "02" },
                                    key: "name",
                                    displayExpr: "name",
                                    valueExpr: "name",
                                    accessToken,
                                    disabled: rowDisabled,
                                    sort: [{ selector: "name", desc: false }],
                                    defaultValue: cellElement.data.availablereasoncode,
                                    onValueChangeCallback: (value, text) => {
                                        cellElement.setValue({ value, text });
                                    },
                                });
                            }}
                            setCellValue={(rowData, newValue) => {
                                rowData.availablereasoncode = newValue.text;
                            }}
                        >
                            <CustomRule
                                validationCallback={(e) => {
                                    const rowData = e.data ?? e.row.data; // current row data
                                    if (rowData.availableflagDiscription === "No" && props.profile?.ReasonMandatory === 'Y' && (!rowData.availablereasoncode || rowData.availablereasoncode.trim() === '')) {
                                        return false; // validation fails
                                    }
                                    return true; // validation passes
                                }}
                                message="Please enter reason code."
                            />
                        </Column>
                        {props.profile?.Translocweight === Options.Yes && (<Column dataField="netweight" caption="Net Wt" dataType="number" format="#,##0.00" />)}
                        {props.profile?.Translocweight === Options.Yes && (<Column dataField="grossweight" caption="Gross Wt" dataType="number" format="#,##0.00" />)}
                        <Column dataField="comment" visible={false} editCellRender={renderCode1Cell}
                            setCellValue={(rowData, newValue) => {

                                rowData.comment = newValue;

                            }} caption='Comment' >
                        </Column>
                        <Toolbar>
                            <Item
                                name="addRowButton"
                            />
                            <Item location="after">
                                <Button
                                    onClick={deleteLocationRecords}
                                    icon="trash"
                                    disabled={!selectedLocationKeys.length || props.disableGridsForRFTransactions === true || props.isCommittedTransaction === true}
                                />
                            </Item>
                            <Item location="after">
                                <div className="separator"></div>
                            </Item> 
                            <Item location="after">
                                <GridLayoutManager gridKey={gridLocationKey} dataGrid={props.locationDataGridRef} setCurrentLayout={currentLocationLayout} />
                            </Item>
                            <Item name="exportButton" />
                            <Item name="columnChooserButton" />
                        </Toolbar>
                    </DataGrid>
                    {showSubLotEntryScreen && (
                        <Popup
                            visible={showSubLotEntryScreen}
                            onHiding={() => setShowSubLotEntryScreen(false)}
                            width="100vw"
                            height="100vh"
                            title=""
                            showCloseButton={true}
                        >
                            <Form id={subLotId} isOpenAsPopUp={true} />
                        </Popup>
                    )}
                    {showSerialNumberScreen && (
                        <Popup
                            visible={showSerialNumberScreen}
                            onHiding={() => setSerialNumberScreen(false)}
                            width="60vw"
                            height="50vh"
                            title="Serial Numbers - Sublot"
                            showCloseButton={true}
                        >
                            <SerialNumbersTab rIndetail={props.sourceId}
                                itemRowId={props.selectedItemRowId} lotRowId={props.selectedLotRowId}
                                formFields={props.formFields}
                                subDetailId={selectedSublotKeys ? selectedSublotKeys[0] : null}
                                disableGridsForRFTransactions={props.disableGridsForRFTransactions}
                                isCommittedTransaction={props.isCommittedTransaction} profile={props.profile}></SerialNumbersTab>
                        </Popup>
                    )}
                    {manuallySelectSublotForShipment && (
                        <Popup
                            visible={manuallySelectSublotForShipment}
                            onHiding={() => setManuallySelectSublotForShipment(false)}
                            width="80vw"
                            height="70vh"
                            title="Manually Select Sublot For Shipment"
                            showCloseButton={true}
                        >
                            <ManuallySelectSublotForShipment rIndetail={props.sourceId}
                               CloseManualShipmentScreen={(aa) => setManuallySelectSublotForShipment(aa)}
                                itemRowId={props.selectedItemRowId} lotRowId={props.selectedLotRowId}
                                formFields={props.formFields}
                                handleManuallySelectSublotForShipmentSave={handleManuallySelectSublotForShipmentSave}
                                rTransactiondetail={props.sourceId}
                                subDetailId={selectedSublotKeys ? selectedSublotKeys[0] : null}
                                disableGridsForRFTransactions={props.disableGridsForRFTransactions}
                                isCommittedTransaction={props.isCommittedTransaction} profile={props.profile}></ManuallySelectSublotForShipment>
                        </Popup>
                    )}
                </div>
            )}
            {showAutoCreateSubLotsPopup.Visible === true && (
                <GenerateAutoSubLotPopup showPopup={showAutoCreateSubLotsPopup} setShowPopup={setShowAutoCreateSubLotsPopup} refreshSublotGrid ={()=>{if (props.subLotdataGridRef.current?.instance) {
                            props.subLotdataGridRef.current.instance().refresh();
                        }}} title="Auto Create Sublots" />
            )}
            {showUpdateTotalWeightPopup.visible === true && (
                <UpdateSubDetailTotalWeight showPopup={showUpdateTotalWeightPopup} setShowPopup={setUpdateTotalWeightPopup} detailRowId={props.sourceId} setSelectedSubLot = {setSelectedSubLot} setLoadPanelVisible={setLoadPanelVisible} refreshSublotGrid={() => {
                    if (props.subLotdataGridRef.current?.instance) {
                        props.subLotdataGridRef.current.instance().refresh();
                    }
                }} title="Update Sub Detail Total Weights" />
            )}
            {showEnterWeightsPopup.visible === true && (
                <EnterWeights showPopup={showEnterWeightsPopup} setShowPopup={setEnterWeightsPopup} stage={props.formFields?.STAGE} setSelectedSubLot={setSelectedSubLot} setLoadPanelVisible={setLoadPanelVisible} RefereshGrid={props.RefereshGrid} changeTotals={props.changeTotals} refreshSublotGrid={() => {
                    if (props.subLotdataGridRef.current?.instance) {
                        props.subLotdataGridRef.current.instance().refresh();
                    }
                }} refreshLocationGrid={() => {
                    if (props.locationDataGridRef.current?.instance) {
                        props.locationDataGridRef.current.instance().refresh();
                    }
                }} title="Enter Weights" />
            )}
        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(SubLotDetailTabs);
